export default __webpack_public_path__ + "static/media/blue_left-chevron_icon.b7ce19f4.svg";